/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CompanyWebhookEventType } from "./CompanyWebhookEventType";
import {
  CompanyWebhookEventTypeFromJSON,
  CompanyWebhookEventTypeFromJSONTyped,
  CompanyWebhookEventTypeToJSON,
  CompanyWebhookEventTypeToJSONTyped,
} from "./CompanyWebhookEventType";

/**
 *
 * @export
 * @interface CreateWebhookRequest
 */
export interface CreateWebhookRequest {
  /**
   *
   * @type {string}
   * @memberof CreateWebhookRequest
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof CreateWebhookRequest
   */
  webhookUrl: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateWebhookRequest
   */
  subscribeToAllEvents: boolean;
  /**
   *
   * @type {Array<CompanyWebhookEventType>}
   * @memberof CreateWebhookRequest
   */
  eventTypes?: Array<CompanyWebhookEventType> | null;
  /**
   *
   * @type {string}
   * @memberof CreateWebhookRequest
   */
  description?: string | null;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof CreateWebhookRequest
   */
  requestHeaders?: { [key: string]: string } | null;
}

/**
 * Check if a given object implements the CreateWebhookRequest interface.
 */
export function instanceOfCreateWebhookRequest(
  value: object,
): value is CreateWebhookRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("webhookUrl" in value) || value["webhookUrl"] === undefined)
    return false;
  if (
    !("subscribeToAllEvents" in value) ||
    value["subscribeToAllEvents"] === undefined
  )
    return false;
  return true;
}

export function CreateWebhookRequestFromJSON(json: any): CreateWebhookRequest {
  return CreateWebhookRequestFromJSONTyped(json, false);
}

export function CreateWebhookRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateWebhookRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    webhookUrl: json["webhookUrl"],
    subscribeToAllEvents: json["subscribeToAllEvents"],
    eventTypes:
      json["eventTypes"] == null
        ? undefined
        : (json["eventTypes"] as Array<any>).map(
            CompanyWebhookEventTypeFromJSON,
          ),
    description: json["description"] == null ? undefined : json["description"],
    requestHeaders:
      json["requestHeaders"] == null ? undefined : json["requestHeaders"],
  };
}

export function CreateWebhookRequestToJSON(json: any): CreateWebhookRequest {
  return CreateWebhookRequestToJSONTyped(json, false);
}

export function CreateWebhookRequestToJSONTyped(
  value?: CreateWebhookRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    webhookUrl: value["webhookUrl"],
    subscribeToAllEvents: value["subscribeToAllEvents"],
    eventTypes:
      value["eventTypes"] == null
        ? undefined
        : (value["eventTypes"] as Array<any>).map(
            CompanyWebhookEventTypeToJSON,
          ),
    description: value["description"],
    requestHeaders: value["requestHeaders"],
  };
}
